import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  InputSignal,
  computed,
  type ModelSignal,
  type OnInit,
} from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';
import { AbstractControl, FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export interface SelectItem<T = any> {
  label?: string;
  value: T;
  styleClass?: string;
  icon?: string;
  subtitle?: string;
  disabled?: boolean;
}

@UntilDestroy()
@Component({
  selector: 'u-radio-button',
  templateUrl: './u-radio-button.component.html',
  styleUrls: ['./u-radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class URadioButtonComponent extends UBaseInfraComponent implements OnInit {
  options: InputSignal<SelectItem[]> = input();
  selectedOption: ModelSignal<string> = model();
  optionTemplate: InputSignal<any> = input();
  showTemplateForAll: InputSignal<boolean> = input(false);
  fieldControl: InputSignal<AbstractControl> = input<AbstractControl>();
  formControl = computed<FormControl>(() => this.fieldControl() as FormControl);
  onClick = output<SelectItem>();

  readonly hasTwoLines = () => {
    return this.options().some((option) => !!option.subtitle);
  };

  ngOnInit() {
    if (this.formControl()) {
      this.selectedOption.set(this.formControl().value);
      this.formControl()
        .valueChanges.pipe(untilDestroyed(this))
        .subscribe((value) => {
          this.selectedOption.set(value);
        });
    }
  }

  onRadioButtonClick(optionValue: string) {
    this.onClick.emit(this.options().find((o) => o.value === optionValue));
  }

  getIconRef() {
    return null;
  }
}
